"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const react_1 = __importStar(require("react"));
const react_i18next_1 = require("react-i18next");
const headerArrowIcon_svg_1 = __importDefault(require("../../../../assets/icons/headerArrowIcon.svg"));
const useScreenSizeDetection_1 = __importDefault(require("../../../../utils/useScreenSizeDetection"));
const S = __importStar(require("./HeaderToggle.style"));
const HeaderToggle = ({ titleText, startDate, endDate, componentToToggle, isCalendarPage, }) => {
    const [isVisible, setIsVisible] = (0, react_1.useState)(true);
    const isMobile = (0, useScreenSizeDetection_1.default)();
    const { t } = (0, react_i18next_1.useTranslation)();
    const toggleVisibility = () => {
        setIsVisible(!isVisible);
    };
    return (react_1.default.createElement(react_1.default.Fragment, null,
        isMobile && (react_1.default.createElement(S.Container, { "$isCalendarPage": isCalendarPage, "$rotated": !isVisible },
            react_1.default.createElement(S.RotatedIcon, { src: headerArrowIcon_svg_1.default, alt: t("headerToggle.arrowIcon"), "$rotated": !isVisible, onClick: toggleVisibility }),
            react_1.default.createElement(S.Heading, { onClick: toggleVisibility }, titleText))),
        !isMobile && (react_1.default.createElement(S.Container, null,
            react_1.default.createElement(S.Heading, null,
                titleText,
                startDate && endDate && (react_1.default.createElement(S.DateField, null,
                    react_1.default.createElement("span", null, startDate),
                    react_1.default.createElement("span", null, "-"),
                    react_1.default.createElement("span", null, endDate)))))),
        isVisible && componentToToggle));
};
exports.default = HeaderToggle;
